import * as React from 'react'
import Styles from './View.module.css'

export class View extends React.Component {
	render(): React.ReactNode {
		return (
			<div className={Styles.container}>
				{this.props.children}
			</div>
		)
	}
}
